"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetupAuthenticator = void 0;
var SetupAuthenticator = (function () {
    function SetupAuthenticator(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
    }
    SetupAuthenticator.prototype.getPackageName = function () { return SetupAuthenticator.PackageName; };
    SetupAuthenticator.prototype.getClassName = function () { return SetupAuthenticator.ClassName; };
    SetupAuthenticator.prototype.getFullClassName = function () { return SetupAuthenticator.FullClassName; };
    SetupAuthenticator.prototype.serialize = function () {
        return {};
    };
    SetupAuthenticator.PackageName = 'net.playq.octopus2.auth';
    SetupAuthenticator.ClassName = 'SetupAuthenticator';
    SetupAuthenticator.FullClassName = 'net.playq.octopus2.auth.SetupAuthenticator';
    return SetupAuthenticator;
}());
exports.SetupAuthenticator = SetupAuthenticator;
var irt_1 = require("@playq/irt");
irt_1.Introspector.register(SetupAuthenticator.FullClassName, {
    full: SetupAuthenticator.FullClassName,
    short: SetupAuthenticator.ClassName,
    package: SetupAuthenticator.PackageName,
    type: irt_1.IntrospectorTypes.Data,
    ctor: function () { return new SetupAuthenticator(); },
    fields: []
});
//# sourceMappingURL=SetupAuthenticator.js.map